import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const Opiniones = () => {
  const opiniones = [
    {
      fecha: "Lunes 10 de Enero , 2022",
      opinion:
        " Pedimos el servicio de limpieza con hidrolavadoras, tardaron menos de lo que esperábamos y mis oficinas quedaron muy limpias ",
      nombre: "Alejandro Becerra",
      cargo: "Gerente General, Puebla, Pue.",
    },
    {
      fecha: "Lunes 14 de Febrero , 2022",
      opinion:
        " Llegaron con todo el equipo necesario, sanitizaron nuestras oficinas y lo que más nos agradó es que llevaban los trajes de protección contra covid, fueron veloces ",
      nombre: "Sergio Navarro",
      cargo: "Director General, Puebla, Pue.",
    },
    {
      fecha: "Viernes 26 de Marzo , 2021",
      opinion:
        " El servicio fue el mejor, no creímos que llegara en tan buenas condiciones y sobre todo puntuales, contrataremos de nuevo! ",
      nombre: "Dayan Castellanos",
      cargo: "Ingeniera Civil, San Andrés Cholula, Puebla",
    },
  ];

  return (
    <div className="relative w-full h-screen flex flex-col items-center justify-center px-4 md:px-24 text-white overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 919 846.68"
          className="w-full h-full"
          preserveAspectRatio="xMidYMid slice"
        >
          <defs>
            <linearGradient
              id="Degradado_sin_nombre_49"
              x1="358.83"
              y1="955.85"
              x2="522.58"
              y2="-12.75"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.12" stopColor="#011e41" />
              <stop offset="0.9" stopColor="#002b6e" />
              <stop offset="1" stopColor="#002d74" />
            </linearGradient>
            <linearGradient
              id="linear-gradient"
              x1="723.52"
              y1="510.91"
              x2="874.37"
              y2="510.91"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#02046f" />
              <stop offset="0.2" stopColor="#393b8f" />
              <stop offset="0.6" stopColor="#a3a3ca" />
              <stop offset="0.87" stopColor="#e5e5f0" />
              <stop offset="1" stopColor="#fff" />
            </linearGradient>
          </defs>
          <rect
            className="cls-2"
            x="4.14"
            y="-32.38"
            width="913.94"
            height="887.24"
            fill="#0047ba"
          />
          <path
            d="M774.87-29.84H-2.85V872.7H819.64v-121a30.58,30.58,0,0,1,9-21.65L938.08,620.61a30.6,30.6,0,0,0,9-21.64V-29.84Z"
            fill="url(#Degradado_sin_nombre_49)"
          />
          {/* puedes pegar el resto de los <path> decorativos si quieres toda la composición */}
        </svg>
      </div>

      <motion.h2
        className="text-4xl font-bold mb-6"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Testimonios
      </motion.h2>

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        className="w-full md:w-3/4"
      >
        {opiniones.map((op, idx) => (
          <SwiperSlide key={idx}>
            <motion.div
              className="flex flex-col items-center gap-6 text-center px-6"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <p className="font-light">{op.fecha}</p>
              <h2 className="text-xl md:text-2xl font-semibold leading-relaxed">
                “{op.opinion}”
              </h2>

              <div className="px-6 py-4 rounded-full text-center">
                <p className="text-lg font-medium">{op.nombre}</p>
                <p className="text-sm">{op.cargo}</p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Opiniones;
